import React, { useEffect } from 'react';
import { useSupliers } from './SuplierStore';
import { MainTable } from '../../Components/MainTable/MainTable';
import Add from './Add';
import Edit from './Edit';
import { useState } from 'react';
import { Modal } from 'antd';
import Transactions from '../Transactions/Transactions';
import { useTransaction } from '../Transactions/TransactionStore';

function Suplier() {
    const [open, setOpen] = useState(false);
    const { supliers, columns, fetchSupliers, deleteSuplier, setEd, setSuplier } = useSupliers();
    const { getKontrTr } = useTransaction();
    useEffect(() => {
        fetchSupliers();
    }, [fetchSupliers]);
    return (
        <>
        <Modal
            title="Mijoz Tranzaksiyalari"
            open={open}
            onOk={() => setOpen(false)}
            onCancel={() => setOpen(false)}
            width={1000}
            footer={null}
        >
            <Transactions />
        </Modal>
            <MainTable 
                pageTitle={'Sotuvchilar'}
                pdata={supliers}
                pcolumns={columns}
                defkey={'id'}
                add={<Add />}
                xwidth={1000}
                edw={1000}
                adw={1000}
                edit={<Edit />}
                onDelete={deleteSuplier}
                onEdit={(rec) => setEd(rec)}
                setEd={setEd}
                viewBtn={true}
                onView={(e, rec) => {
                    setSuplier(rec);
                    setOpen(true);
                    getKontrTr(rec.id);
                }}
            />
        </>
    );
}

export default Suplier;